const BackHome = [
	'[Verse 1]',
	"I'm gonna need you to raise your glass",
	"I don't care what you put in it",
	"Here's to nights that you can't take back",
	'We live hard but we love to laugh',
	'',
	"We all thought that we'd get rich fast",
	'Hop the plane out for greener grass',
	'Found out the green is cash',
	"Don't compare to the friends that last",
	'',
	'[Pre-Chorus]',
	"See, we won't forget where we came from",
	"The city won't change us",
	'We beat to the same drum',
	"No, we won't forget where we came from",
	"The city can't change us",
	'We beat to the same drum, the same drum (Hey!)',
	'',
	'[Chorus]',
	'La-dah-dah-dah-dah-dah-dah-dah',
	'La-dah-dah-dah-dah-dah-dah-doe (Hey!)',
	'And no matter where we go',
	'We always find our way back home (Hey!)',
	'',
	'La-dah-dah-dah-dah-dah-dah-dah',
	'La-dah-dah-dah-dah-dah-dah-doe (Hey!)',
	'And no matter where we go',
	'We always find our way back home',
	'',
	'[Verse 2]',
	"So here's to the cheap sunglasses",
	'Redbull and minivans and',
	'People who had your back when',
	"The world didn't understand",
	'',
	'[Pre-Chorus]',
	"See, we won't forget where we came from",
	"The city won't change us",
	'We beat to the same drum',
	"No, we won't forget where we came from",
	"The city can't change us",
	'We beat to the same drum, the same drum (Hey!)',
	'',
	'[Chorus]',
	'La-dah-dah-dah-dah-dah-dah-dah',
	'La-dah-dah-dah-dah-dah-dah-doe (Hey!)',
	'And no matter where we go',
	'We always find our way back home (Hey!)',
	'',
	'La-dah-dah-dah-dah-dah-dah-dah',
	'La-dah-dah-dah-dah-dah-dah-doe (Hey!)',
	'And no matter where we go',
	'We always find our way back home',
	'',
	'[Bridge]',
	'When ties loosen',
	"We're losin' touch",
	'And fa--ading away',
	"We'll still be raising our cups",
	'To the same damn things',
	'',
	'[Chorus]',
	"Oh no, the city won't change us",
	"Oh no, the city won't change us",
	"Oh no, the city won't change us",
	"Oh no, the city won't change us",
	"Won't change us (Hey!)",
	'',
	'La-dah-dah-dah-dah-dah-dah-dah',
	'La-dah-dah-dah-dah-dah-dah-doe',
	'And no matter where we go',
	'(no chords)',
	'We always find our way back home',
	'',
	'La-dah-dah-dah-dah-dah-dah-dah',
	'La-dah-dah-dah-dah-dah-dah-doe',
	'And no matter where we go',
	'We always find our way back home (Hey!)',
	'',
	'La-dah-dah-dah-dah-dah-dah-dah',
	'La-dah-dah-dah-dah-dah-dah-doe',
	'And no matter where we go',
	'We always find our way back home',
	'',
	'[Outro]',
	'We always find our way back home',
	'Yeah, we always find our way back home',
];

export default BackHome;
